import { render, staticRenderFns } from "./IncentivesPage.vue?vue&type=template&id=a71cb17c&"
import script from "./IncentivesPage.vue?vue&type=script&lang=js&"
export * from "./IncentivesPage.vue?vue&type=script&lang=js&"
import style0 from "./IncentivesPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports